import 'vite/modulepreload-polyfill'
import * as Product from "../../components/Product";
import * as Ecommerce from "../../components/Ecommerce";
import * as Blocks from "../../components/Blocks";
import * as Blogs from "../../components/Blogs";
import * as Client from "../../components/Client";
import * as Account from "../../components/Account";
import * as Wishlist from "../../components/Wishlist";

function getComponentEntries(obj) {
    return Object.entries(obj)
        .filter(([, component]) => component.displayName)
        .map(([, component]) => ({
            name: component.displayName,
            element: component,
        }));
}

let cachedComponents = null;

// Lazy loading function for component modules
async function loadComponentModule(moduleName) {
    try {
        switch (moduleName) {
            case 'Product':
                return await import("../../components/Product");
            case 'Ecommerce':
                return await import("../../components/Ecommerce");
            case 'Blocks':
                return await import("../../components/Blocks");
            case 'Blogs':
                return await import("../../components/Blogs");
            case 'Client':
                return await import("../../components/Client");
            case 'Account':
                return await import("../../components/Account");
            case 'Wishlist':
                return await import("../../components/Wishlist");
            default:
                throw new Error(`Unknown module: ${moduleName}`);
        }
    } catch (error) {
        console.error(`Failed to load component module ${moduleName}:`, error);
        return {};
    }
}

export async function getComponents() {
    if (cachedComponents) return cachedComponents;

    // Load all component modules dynamically
    const moduleNames = ['Product', 'Ecommerce', 'Blocks', 'Blogs', 'Client', 'Account', 'Wishlist'];
    const modules = await Promise.all(
        moduleNames.map(name => loadComponentModule(name))
    );

    // Aggregate all component entries from each source
    cachedComponents = modules.flatMap(getComponentEntries);
    return cachedComponents;
}

// Export a synchronous version for compatibility
export function getComponentsSync() {
    if (cachedComponents) return cachedComponents;

    // Fallback to synchronous loading for immediate needs
    const sources = [
        Product,
        Ecommerce,
        Blocks,
        Blogs,
        Client,
        Account,
        Wishlist
    ];
    cachedComponents = sources.flatMap(getComponentEntries);
    return cachedComponents;
}
